export interface WorkspaceData {
  title: string|null
  description: string|null
  participantIds: Array<string>
  private: boolean
}

export const initWorkspaceData = (): WorkspaceData => ({
    title: null,
    description: null,
    participantIds: [],
    private: true
})
